import React, { Component } from "react";
import Events from "../../components/dashboard/Events";
import Fees from "../../components/dashboard/Fees";
import PendingApproval from "../../components/dashboard/PendingApproval";
import ProspectsCorporateMember from "../../components/dashboard/ProspectsCorporateMember";
import DashboardServices from "../../services/axiosServices/apiServices/DashboardServices";
import SwalServices from "../../services/swalServices/SwalServices";
import { getAuthProps } from "../../utils/AuthenticationLibrary";
import { Navigate } from "react-router-dom";
import moment from "moment";
import { saveAs } from "file-saver";

export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.getDashboardServices = new DashboardServices();
    this.swalServices = new SwalServices();
    this.state = {
      isLoading: false,
      route: null,
      entries: "",

      dashboardDetails: {


        totalProspects: 0,
        submitted: 0,
        pendingMembershipCommittee: 0,
        pendingManagementCommittee: 0,
        membershipCommitteeApproved: 0,
        managementCommitteeApproved: 0,
        clarifications: 0,
        pendingPayment: 0,
        completed: 0,
        totalActiveMembers: 0,
        expiryInThirdYear: 0,
        expiryInSecondYear: 0,


        businessMatchingPaid: 0,
        businessMatchingPendingPayment: 0,
        businessMatchingTotalAmount: 0,
        closedLost: 0,
        closedSuccessful: 0,
        closedToRevisit: 0,
        eventsPaid: 0,
        eventsPendingPayment: 0,
        eventsTotalAmount: 0,
        expiryWithin30: 0,
        expiryWithin45: 0,
        expiryWithin60: 0,
        inProgress: 0,
        membershipAssociateFee: 0,
        // membershipQualifyingFee: 0,
        membershipOrdinaryFee: 0,
        membershipTotalAmount: 0,
        notStarted: 0,
        renewedlast7: 0,
        sponsorshipCorporateFee: 0,
        sponsorshipIndividualFee: 0,
        sponsorshipTotalAmount: 0,
        totalCorporateMember: 0,
        adminDashboardEventDetailList: [],
        adminDashboardPendingApprovalList: [],
        currentDate: "2023-02-09 17:40:13.070",
        totalActiveCorporateMembers: 0,
        totalInactiveCorporateMembers: 0,
        totalInactiveCorporateMembersinTaskList: 0,
        renewalMemberProratedIn2025: "",
        activeMember: "",

        //eVoting Details
        startDate: "",
        endDate: "",
        totalRegisteredVoters: 0,
        totalVotersSubmittedBallot: 0,
        totalVotersYetToSubmitBallot: 0
      },
      roleId: 0,
    };
  }

  getAdminDashboardDetail = () => {
    this.setState({ isLoading: true });
    this.getDashboardServices.getAdminDashboardDetail().then((response) => {
      if (response != null) {
        this.setState({ dashboardDetails: response }, () => {
          this.geteVotingAdminDashboardDetails();
        });
      } else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isLoading: false });
    });
  };

  geteVotingAdminDashboardDetails = () => {
    this.setState({ isLoading: true });
    this.getDashboardServices.geteVotingAdminDashboardDetails().then((response) => {
      if (response && response.statusCode === 200 && response.responseItem != null) {

        let dashboard = this.state.dashboardDetails;
        let responseData = response.responseItem.responseContent;

        dashboard.startDate = responseData.startDate ? moment(responseData.startDate).format('YYYY-MM-DD') : (responseData.startDate ? moment(responseData.startDate).format('YYYY-MM-DD') : "");
        dashboard.endDate = responseData.endDate ? moment(responseData.endDate).format('YYYY-MM-DD') : (responseData.EndDate ? moment(responseData.EndDate).format('YYYY-MM-DD') : "");
        dashboard.totalRegisteredVoters = responseData.totalRegisteredVoters;
        dashboard.totalVotersSubmittedBallot = responseData.totalVotersSubmittedBallot;
        dashboard.totalVotersYetToSubmitBallot = responseData.totalVotersYetToSubmitBallot;
        this.setState({ dashboardDetails: dashboard });
      }
      this.setState({ isLoading: false });
    });
  };

  componentDidMount() {
    let cookies = getAuthProps();
    if (cookies && cookies.roleId) {
      this.setState({ roleId: cookies.roleId })
    }
    this.getAdminDashboardDetail();
  }

  handleRedirectforProspect = (storageKey, storageValue) => {
    localStorage.setItem(storageKey, storageValue);
    this.setState({ route: "/Membership/MembershipTaskList" });
  };

  handleRedirectforCorporate = (storageKey, storageValue) => {
    localStorage.setItem(storageKey, storageValue);
    this.setState({ route: "/Membership/MembershipRenewalDashboard" });
  };

  downloadNonVoters = () => {
    this.setState({ isLoading: true });

    this.getDashboardServices.exportExcelForNonVoters().then(async (response) => {
        if (response.status === 200 && response.data) {

          if (response.data.type === "application/json") {
            const text = await response.data.text();
            const result = JSON.parse(text);

            this.setState({ isLoading: false });
            this.swalServices.Error(result.message || "No non-voters available.");
            return;
          }

          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });

          saveAs(blob, "Voters_Yet_To_Submit_Ballot.xlsx");

          this.setState({ isLoading: false });
          this.swalServices.Success("Non-Voters Report Downloaded Successfully!");
        } else {
          this.setState({ isLoading: false });
          this.swalServices.Error("No non-voters available.");
        }
      })
      .catch((error) => {
        console.error("Error downloading non-voter report:", error);
        
        this.setState({ isLoading: false });
        this.swalServices.Error("Unable to download the report.");
      });
  };

  render() {
    if (this.state.route != null) {
      return <Navigate to={this.state.route} />;
    }
    return (
      <div className="main-body-section bg-white h-auto justify-between">
        {/* Prospects Corporate Member Start */}
        <ProspectsCorporateMember
          dashboardDetails={this.state.dashboardDetails}
          redirectToProspect={this.handleRedirectforProspect}
          redirecToCorporate={this.handleRedirectforCorporate}
          roleId={this.state.roleId}
          downloadNonVoters={this.downloadNonVoters}

        />
        {/* Prospects Corporate Member Ends */}

        {/* PendingApproval Start */}
        {/* <PendingApproval
          dashboardDetails={this.state.dashboardDetails}
        /> */}
        {/* PendingApproval End */}

        {/* Events Start */}
        {/* <Events
          dashboardDetails={this.state.dashboardDetails}
        /> */}
        {/* Events End */}

        {/* Fees Start */}
        {/* <Fees
          dashboardDetails={this.state.dashboardDetails}
        /> */}
        {/* Fees End */}
      </div>
    );
  }
}
